function updateSelectors() {
  checkBoxes = Array.from(document.querySelectorAll('input[name="free-sample"]'));
  currentSelection = checkBoxes.filter( input => input.checked )[0];
  cartItemsContainer = document.querySelector('#main-cart-items .cart-items > tbody');

  checkBoxes.forEach(box => {
    box.removeEventListener("change", detectCheckedSample, true)
  });
  checkBoxes.forEach(box => {
    box.addEventListener("change", detectCheckedSample, true)
  });
}

function detectCheckedSample(box) {
    if(box.target.checked){
        addSampleToCart()
    }
}

let checkBoxes,
    currentSelection,
    cartItemsContainer;
updateSelectors();


window.addEventListener('custom:reattachSample', () => {
  cartItemsContainer = document.querySelector('#main-cart-items .cart-items > tbody');
  if(!cartItemsContainer){
    document.querySelector('#shopify-section-sample-choice').style.display = "none";
  }else{
      document.querySelector('#shopify-section-sample-choice').style.display = "block";
  }
  fetch('/?sections=sample-choice')
  .then(response => response.json())
  .then(text => {
    const resultsMarkup = new DOMParser().parseFromString(text['sample-choice'], 'text/html').querySelector('#sample__list').innerHTML;
    document.getElementById('sample__list').innerHTML = resultsMarkup
    updateSelectors();
  });
})

function addSampleToCart() {
  let checkedInput = checkBoxes.filter( input => input.checked )[0]
  if(checkedInput){
    let formData = {
      updates: {
        [checkedInput.dataset.variantId] : 1,
      }
    };

    if(currentSelection) {
      formData.updates[currentSelection.dataset.variantId] = 0
    }

    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        fetch('/?view=cart')
        .then(response => response.text())
        .then(cartData => {
            document.querySelector('#main-cart-items .js-contents').innerHTML = cartData;
        });

        fetch('/?view=cart-total')
        .then(response => response.text())
        .then(cartTotal => {
            document.querySelector('#main-cart-footer .js-contents').innerHTML = cartTotal;
        });

        updateSelectors();

      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}